import { render, staticRenderFns } from "./BaseComponent.vue?vue&type=template&id=4723d696&scoped=true"
import script from "./BaseComponent.vue?vue&type=script&lang=ts"
export * from "./BaseComponent.vue?vue&type=script&lang=ts"
import style0 from "./BaseComponent.vue?vue&type=style&index=0&id=4723d696&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4723d696",
  null
  
)

export default component.exports